export const wordCount = (input: string): number => {
	return input.split(' ').length;
};
